export const FETCH_RESERVATION_PRICING_STARTED = 'FETCH_RESERVATION_PRICING_STARTED';
export const FETCH_RESERVATION_PRICING_SUCCEEDED = 'FETCH_RESERVATION_PRICING_SUCCEEDED';
export const FETCH_RESERVATION_PRICING_FAILED = 'FETCH_RESERVATION_PRICING_FAILED';

export const FETCH_RESERVATIONS_PRICE_STARTED = 'FETCH_RESERVATIONS_PRICE_STARTED';
export const FETCH_RESERVATIONS_PRICE_SUCCEEDED = 'FETCH_RESERVATIONS_PRICE_SUCCEEDED';
export const FETCH_RESERVATIONS_PRICE_FAILED = 'FETCH_RESERVATIONS_PRICE_FAILED';
